import { render, staticRenderFns } from "./Unsupported.vue?vue&type=template&id=8b913c9e"
import script from "./Unsupported.vue?vue&type=script&lang=js"
export * from "./Unsupported.vue?vue&type=script&lang=js"
import style0 from "./Unsupported.vue?vue&type=style&index=0&id=8b913c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports